import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as GrIcons from "react-icons/gr";
import "./makeClaim.css";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const variants = {
  enter: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
};

import mtekLogo  from "../../../assets/images/mtek-logo.svg"


function MakeClaim({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    setCurrentScreen("make-claim");
    sessionStorage.setItem("claim-screens", "make-claim");
  });

  const [claimInfo, setClaimInfo] = useState({
    bookingDate:"",
    startDate: "",
    endDate: "",
    agentName: "",
    accomodationDetails: ""
  })

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setClaimInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const saveDetails = () => {
    if(!claimInfo.bookingDate){
      document.getElementById('bookingDate')?.focus
      toast.warning(t("makeClaim.enterBookingDate"))
      return
    }
    if(!claimInfo.agentName){
      document.getElementById('agentName')?.focus
      toast.warning(t("makeClaim.enterAgentName"))
      return
    }
    if(!claimInfo.startDate){
      document.getElementById('startDate')?.focus
      toast.warning(t("makeClaim.enterStartDate"))
      return
    }
    if(!claimInfo.endDate){
      document.getElementById('endDate')?.focus
      toast.warning(t("makeClaim.enterEndDate"))
      return
    }
    if(!claimInfo.accomodationDetails){
      document.getElementById('accomodationDetails')?.focus
      toast.warning(t("makeClaim.enterAccommodationDetails"))
      return
    }
    sessionStorage.setItem("claim", JSON.stringify(claimInfo))
    setCurrentScreen("claim-options");
    sessionStorage.setItem("claim-screens", "claim-options");
  };

  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div
          className="image text-center mt-5 mb-3"
          onClick={() => navigate("/")}
        >
          <img src={mtekLogo} alt="travel icon" />
        </div>
        <div className="reg-title text-center mb-4">
          <span style={{ color: "#000000" }}>
            {t("makeClaim.provideDetailsHeader")}
          </span>{" "}
          <span className="span-title">{t("makeClaim.claimTitle")}</span>  
        </div>
        <div className="ky-inputs-inner-container">
          <div className="ky-input-wrapper">
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container ky-input-container-claim mt-4"
            >
              <label className="text-left-label mb-2" htmlFor="bookingDate">
                {t("makeClaim.bookingDateLabel")}{" "}
              </label>
              <br />
              <input
                id="bookingDate"
                name="bookingDate"
                type="date"
                onChange={handleInputChange}
                value={claimInfo.bookingDate}
              ></input>
            </motion.div>
          </div>
          <div className="ky-input-wrapper">
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container ky-input-container-claim mt-4"
            >
              <label
                className="text-left-label mb-2"
                htmlFor="agentName"
              >
                {t("makeClaim.agentNameLabel")}
              </label>
              <br />
              <input
                id="agentName"
                name="agentName"
                type="text"
                onChange={handleInputChange}
                value={claimInfo.agentName}
                placeholder={t("makeClaim.typeHere")}
              ></input>
            </motion.div>
          </div>
        </div>
        <div className="ky-inputs-inner-container w-100">
          <div className="ky-input-wrapper">
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container ky-input-container-claim mt-4"
            >
              <label className="text-left-label mb-2" htmlFor="postal">
                {t("makeClaim.travelDatesLabel")}
              </label>
              <br />
              <div className="postal-area-container">
                <input
                  id="startDate"
                  name="startDate"
                  type="date"
                  onChange={handleInputChange}
                  value={claimInfo.startDate}
                ></input>

                <input
                  id="endDate"
                  name="endDate"
                  type="date"
                  onChange={handleInputChange}
                  value={claimInfo.endDate}
                ></input>
              </div>
            </motion.div>
          </div>

          <div className="ky-input-wrapper">
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container ky-input-container-claim mt-4"
            >
              <label
                className="text-left-label mb-2"
                htmlFor="accomodationDetails"
              >
                {t("makeClaim.accommodationDetailsLabel")}
              </label>
              <br />
              <div className="postal-area-container">
                <input
                  id="accomodationDetails"
                  name="accomodationDetails"
                  type="text"
                  onChange={handleInputChange}
                  value={claimInfo.accomodationDetails}
                  placeholder={t("makeClaim.typeHere")}
                ></input>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="previous">
            <span
              onClick={(e) => {
                sessionStorage.removeItem("claim-screens");
                navigate(-1);
              }}
            >
              <span className="GrIcon me-2">
                <GrIcons.GrFormPreviousLink />
              </span>{" "}
              <span className="previous">{t("makeClaim.previous")}</span>
            </span>
          </div>
          <div className="mt-5" onClick={() => saveDetails()}>
            <button className="pointer-btn next-btn">
              {" "}
              <span>
                {t("makeClaim.proceed")}{" "}
                <span className="GrIcon ms-3">
                  <GrIcons.GrFormNextLink />
                </span>
              </span>{" "}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default MakeClaim;
